// extracted by mini-css-extract-plugin
export default {"map":"MapSection_map__tfCab","mapLabel":"MapSection_mapLabel__bMuv7","clickLayer":"MapSection_clickLayer__nVR+O"};